import LocalStorage from 'utils/bom-dom-manipulation/local-storage';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { isMobile } from 'utils/is-mobile';

export type TSportNft = {
  externalId: number;
  collectionId: number;
  referenceId: string;
  addDate: string;
  receiveDate: null;
  mobileImgUrl: string;
  desktopImgUrl: string;
  claimUrl: string;
};

export const SportNft = ({ sportNft }: { sportNft: TSportNft }) => {
  const handleNftClick = () => {
    const authData = JSON.parse(
      LocalStorage.getItem(storageKeyName('account', 'AUTH_DATA'))
    );

    if (authData) {
      const claimUrl = sportNft.claimUrl
        .replace('{token}', authData.auth_token)
        .replace('{partnerId}', `${SpringConfigs.PARTNER_ID}`);

      window.open(claimUrl, '_blank');
    }
  };

  return (
    <div className="sportNft" onClick={handleNftClick}>
      <img
        className="sportNft__img"
        src={isMobile() ? sportNft.mobileImgUrl : sportNft.desktopImgUrl}
      />
    </div>
  );
};
